import { Box, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button, DateInput, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import PaperComponent from "../../unit/PaperComponent";
import CustomNumberTextField from "../../unit/forms/CustomNumberTextField";
import useNotify from "../../unit/useNotify";
export default function CustomLoanRefundDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record: recordProp } = props;
  const [open, setOpen] = React.useState(false);
  const [showOffRefund, setShowOffRefund] = React.useState(false);

  const achRefundCheck = recordProp?.achRefundCheck;
  // console.log("achRefundCheck", achRefundCheck);
  const defaultRefundAmount = Math.abs(
    recordProp?.loan?.activePrincipalBalance || 0
  );
  const [refunddate, setRefundDate] = React.useState(
    new Date().toISOString().split("T")[0]
  );
  const [refundamount, setRefundAmount] = React.useState(defaultRefundAmount);
  const [refundAmountError, setRefundAmountError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const refresh = useRefresh();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <div>
      <Button
        label="Refund"
        variant="contained"
        size="medium"
        color="primary"
        sx={{ marginLeft: "10px", width: "175px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="loan-update-charged-off-status-dialog"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.loannum = recordProp?.loan?.loanNum;
            console.log("update loan status formJson =====>", formJson);
            //charged amount, recovery amount, net charge off amount, recovery date can't not be negative, must have value
            if (refundamount <= 0 || formJson.refunddate === "") {
              errorNotify("Please check all the inputs");
              return;
            }
            formJson.refundamount = refundamount;
            //refunddate must be a valid date, and >= today
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const refundDate2 = new Date(refunddate);
            if (isNaN(refundDate2.getTime())) {
              errorNotify("Please enter a valid date");
              return;
            }
            console.log("refundDate2", refundDate2);
            console.log("today", today);
            if (refundDate2 < today) {
              errorNotify("Refund date must be today or later");
              return;
            }
            formJson.actionFrom = "paidoff";
            formJson.actionType = "offline";
            setIsLoading(true);
            const reqUrl = `loans/actions/refundPaidOff`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            // console.log(responseBack.data);
            if (responseBack && responseBack.code == "200") {
              successNotify("Data saved successfully");
              handleClose();
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
            }
            setIsLoading(false);
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle title={`Paid-Off Loan`} subTitle="Refund" />
        </DialogTitle>
        <DialogContent>
          <Box>
            <DialogContentText>
              <HeaderLabelTitle
                fullWidth
                title={"ACH Refund"}
                suffix=""
                sx={{
                  mb: 1,
                  ml: 2,
                  color: achRefundCheck?.status == 201 ? "grey" : "green",
                }}
                align="left"
              />
              <Typography variant="body1" sx={{ mb: 2, ml: 5 }}>
                ACH Refund is not available for one of the following reasons:
                <ul>
                  {achRefundCheck?.details?.map((item: any, index: any) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </Typography>

              <span
                onClick={() => {
                  setShowOffRefund(!showOffRefund);
                }}
              >
                <HeaderLabelTitle
                  fullWidth
                  title={"Offline Refund"}
                  suffix=""
                  sx={{
                    mb: 1,
                    ml: 2,
                    color: "#00CCB1",
                    cursor: "pointer",
                  }}
                  align="left"
                />
              </span>
              <Typography variant="body1" sx={{ mb: 2, ml: 5 }}>
                Record an offline refund to bring the loan’s remaining balance
                to 0.
              </Typography>
            </DialogContentText>
            {showOffRefund && (
              <Grid container sx={{ mt: 2, mb: 2, pb: 2 }}>
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle fullWidth title="Refund Amount" />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField
                      fullWidth
                      id="refundamount"
                      name="refundamount"
                      variant="outlined"
                      defaultValue={refundamount}
                      sx={{
                        "& .MuiInputBase-input": {
                          backgroundColor: "#eee",
                        },
                      }}
                      disabled={true}
                      error={refundamount <= 0}
                      helperText={
                        refundamount <= 0 ? "value must be greater than 0" : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
                {/* refund Date */}
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle fullWidth title="Refund Date" />
                  </Grid>
                  <Grid item xs={5}>
                    <CustomDateTextInput
                      fullWidth
                      id="refunddate"
                      name="refunddate"
                      variant="outlined"
                      defaultValue={refunddate}
                      value={refunddate}
                      onChange={(e) => {
                        setRefundDate(e);
                      }}
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle
                      fullWidth
                      title="Add Note (Max 150 Characters)"
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField
                      id="notes"
                      name="notes"
                      placeholder="Notes"
                      multiline={true}
                      minRows={3}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              </Grid>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          {showOffRefund && (
            <CustomButtonSubmit label="Confirm" disabled={isLoading} />
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
